import React, {Component} from 'react';
import Styles from './style.css';
import cx from 'classnames';
import {langRegister} from "../../services/langRegister";
import {Line, Doughnut} from 'react-chartjs-2';
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class BoosterHomeCampaigns extends Component {

    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            data: null,
            show: true,
            channels_style: {
                line: {
                    instagram: {
                        title: "instagram",
                        backgroundColor: 'rgba(204,237,243, 0.7)',
                    },
                    fb: {
                        title: "facebook",
                        backgroundColor: 'rgba(51,184,207, 0.9)',
                    },
                    bing: {
                        title: "bing",
                        backgroundColor: 'rgba(153,219,231, 0.9)',
                    },
                    google: {
                        title: "google",
                        backgroundColor: 'rgba(26,107,133, 0.9)',
                    }
                },
                doughnut: {
                    instagram: {
                        title: "instagram",
                        backgroundColor: 'rgba(204,237,243, 0.7)',
                        hoverBackgroundColor: 'rgba(204,237,243, 0.7)'
                    },
                    fb: {
                        title: "facebook",
                        backgroundColor: 'rgba(51,184,207, 0.9)',
                        hoverBackgroundColor: 'rgba(51,184,207, 0.9)'
                    },
                    bing: {
                        title: "bing",
                        backgroundColor: 'rgba(153,219,231, 0.9)',
                        hoverBackgroundColor: 'rgba(153,219,231, 0.9)'
                    },
                    google: {
                        title: "google",
                        backgroundColor: 'rgba(26,107,133, 0.9)',
                        hoverBackgroundColor: 'rgba(26,107,133, 0.9)'
                    }
                }
            },
            chartData: {
                labels: ["1", "2", "3", "4", "5", "6"],
                datasets: [{
                    backgroundColor: 'rgba(51,184,207,0.7)',
                    borderColor: '#33b8cf',
                    data: [],
                    borderWidth: 2,
                    radius: 4,
                    pointBackgroundColor: "#ffffff",
                    pointHoverBorderColor: '#33b8cf',
                    pointHoverBackgroundColor: "#ffffff",
                }]
            },
            options: {
                scales: {
                    xAxes: [
                        {
                            display: false,
                        }
                    ],
                    yAxes: [
                        {
                            display: false,
                        }
                    ]
                },
                tooltips: {
                    enabled: false
                },
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                responsive: true,
                maintainAspectRatio: false,
            },
            doughnutData: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [],
                    borderColor: [
                        'transparent',
                        'transparent',
                        'transparent',
                        'transparent',
                    ],
                    hoverBorderColor: [
                        'transparent',
                        'transparent',
                        'transparent',
                        'transparent',
                    ],
                    hoverBackgroundColor: []
                }],
            },
            doughnutOptions: {
                scales: {
                    xAxes: [
                        {
                            display: false,
                        }
                    ],
                    yAxes: [
                        {
                            display: false,
                        }
                    ]
                },
                tooltips: {
                    enabled: false
                },
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                cutoutPercentage: 65,
                responsive: false,
                maintainAspectRatio: false,
                engagement: 0,
                reactions: 0,
            },
        };
    };

    componentWillMount() {

        //SET COLORS
        if(salesChannelRegister.get("name") === "propertybooster"){

            this.state.channels_style.line.instagram.backgroundColor = "rgba(204,237,243, 0.7)";
            this.state.channels_style.line.fb.backgroundColor = "rgba(51,184,207, 0.9)";
            this.state.channels_style.line.bing.backgroundColor = "rgba(153,219,231, 0.9)";
            this.state.channels_style.line.google.backgroundColor = "rgba(26,107,133, 0.9)";

            this.state.channels_style.doughnut.instagram.backgroundColor = "rgba(204,237,243, 0.7)";
            this.state.channels_style.doughnut.instagram.hoverBackgroundColor = "rgba(204,237,243, 0.7)";
            this.state.channels_style.doughnut.fb.backgroundColor = "rgba(51,184,207, 0.9)";
            this.state.channels_style.doughnut.fb.hoverBackgroundColor = "rgba(51,184,207, 0.9)";
            this.state.channels_style.doughnut.bing.backgroundColor = "rgba(153,219,231, 0.9)";
            this.state.channels_style.doughnut.bing.hoverBackgroundColor = "rgba(153,219,231, 0.9)";
            this.state.channels_style.doughnut.google.backgroundColor = "rgba(26,107,133, 0.9)";
            this.state.channels_style.doughnut.google.hoverBackgroundColor = "rgba(26,107,133, 0.9)";

            this.state.chartData.datasets[0].borderColor = "#33B8CF";
            this.state.chartData.datasets[0].pointHoverBorderColor = "#33B8CF";
            this.state.chartData.datasets[0].backgroundColor = "rgba(51,184,207,0.7)";

            this.setState({
                channels_style: this.state.channels_style,
                chartData: this.state.chartData
            });

        }else if(salesChannelRegister.get("name") === "boostabostad"){

            this.state.channels_style.line.instagram.backgroundColor = "rgba(229,245,222, 0.7)";
            this.state.channels_style.line.fb.backgroundColor = "rgba(126,207,91, 0.9)";
            this.state.channels_style.line.bing.backgroundColor = "rgba(174,236,147, 0.9)";
            this.state.channels_style.line.google.backgroundColor = "rgba(104,171,75, 0.9)";

            this.state.channels_style.doughnut.instagram.backgroundColor = "rgba(229,245,222, 0.7)";
            this.state.channels_style.doughnut.instagram.hoverBackgroundColor = "rgba(229,245,222, 0.7)";
            this.state.channels_style.doughnut.fb.backgroundColor = "rgba(126,207,91, 0.9)";
            this.state.channels_style.doughnut.fb.hoverBackgroundColor = "rgba(126,207,91, 0.9)";
            this.state.channels_style.doughnut.bing.backgroundColor = "rgba(174,236,147, 0.9)";
            this.state.channels_style.doughnut.bing.hoverBackgroundColor = "rgba(174,236,147, 0.9)";
            this.state.channels_style.doughnut.google.backgroundColor = "rgba(104,171,75, 0.9)";
            this.state.channels_style.doughnut.google.hoverBackgroundColor = "rgba(104,171,75, 0.9)";

            this.state.chartData.datasets[0].borderColor = "#7ECF5B";
            this.state.chartData.datasets[0].pointHoverBorderColor = "#7ECF5B";
            this.state.chartData.datasets[0].backgroundColor = "rgba(126,207,91,0.7)";

            this.setState({
                channels_style: this.state.channels_style,
                chartData: this.state.chartData
            });

        }else if(salesChannelRegister.get("name") === "yieldlock"){

            this.state.channels_style.line.instagram.backgroundColor = "rgba(230,233,235, 0.9)";
            this.state.channels_style.line.fb.backgroundColor = "rgba(128,147,157, 0.9)";
            this.state.channels_style.line.bing.backgroundColor = "rgba(191,201,206, 0.7)";
            this.state.channels_style.line.google.backgroundColor = "rgba(0,39,58, 0.9)";

            this.state.channels_style.doughnut.instagram.backgroundColor = "rgba(230,233,235, 0.9)";
            this.state.channels_style.doughnut.instagram.hoverBackgroundColor = "rgba(230,233,235, 0.9)";
            this.state.channels_style.doughnut.fb.backgroundColor = "rgba(128,147,157, 0.9)";
            this.state.channels_style.doughnut.fb.hoverBackgroundColor = "rgba(128,147,157, 0.9)";
            this.state.channels_style.doughnut.bing.backgroundColor = "rgba(191,201,206, 0.7)";
            this.state.channels_style.doughnut.bing.hoverBackgroundColor = "rgba(191,201,206, 0.7)";
            this.state.channels_style.doughnut.google.backgroundColor = "rgba(0,39,58, 0.9)";
            this.state.channels_style.doughnut.google.hoverBackgroundColor = "rgba(0,39,58, 0.9)";

            this.state.chartData.datasets[0].borderColor = "#00273A";
            this.state.chartData.datasets[0].pointHoverBorderColor = "#00273A";
            this.state.chartData.datasets[0].backgroundColor = "rgba(0,39,58,0.7)";

            this.setState({
                channels_style: this.state.channels_style,
                chartData: this.state.chartData
            });

        }

        this._updateData();
    }

    _updateData(){
        dataRegister.publicCampaigns(salesChannelRegister.get("market") ,langRegister.lang()).then((response) => {
            if(response.length > 0){
                this.setState({data: response}, () => {
                    this._updateChartData();
                });
            }
        }, (error) => {});
    }

    _updateChartData() {
        try{
            if(this.state.data){
                let datasets = [];
                // SET LINE CHART
                let channels_observations = {};
                for(let i = 0; i < this.state.data[this.state.index].observations.length; i++){
                    for(let m = 0; m < this.state.data[this.state.index].channels.length; m++){
                        let key = this.state.data[this.state.index].channels[m];
                        if(channels_observations[key]){
                            try{
                                channels_observations[key].observations.push(this.state.data[this.state.index].observations[i].channels[key].impressions);
                            }catch (e) {}
                        }else{
                            try{
                                channels_observations[key] = {backgroundColor: null, observations: [0], title: null};
                                channels_observations[key].backgroundColor = this.state.channels_style.line[key].backgroundColor;
                                channels_observations[key].title = this.state.channels_style.line[key].title;
                                channels_observations[key].observations.push(this.state.data[this.state.index].observations[i].channels[key].impressions);
                            }catch (e) {}
                        }
                    }
                }

                for(let m = 0; m < this.state.data[this.state.index].channels.length; m++){
                    let key = this.state.data[this.state.index].channels[m];
                    datasets.unshift({
                        data: channels_observations[key].observations,
                        backgroundColor: channels_observations[key].backgroundColor,
                        borderColor: 'transparent',
                        radius: 0,
                        label: channels_observations[key].title
                    });
                }

                // SET DOUGHNUT DATA
                let observations = [];
                let channels = {};
                for(let i = 0; i < this.state.data[this.state.index].observations.length; i++){
                    for(let m = 0; m < this.state.data[this.state.index].channels.length; m++) {
                        let key = this.state.data[this.state.index].channels[m];
                        if(channels[key]){
                            if(this.state.data[this.state.index].observations[i].channels[key]){
                                channels[key].value = +channels[key].value + +this.state.data[this.state.index].observations[i].channels[key].impressions;
                            }else{
                                channels[key].value = channels[key].value + 0;
                            }
                        }else{
                            channels[key] = {};
                            channels[key].title = this.state.channels_style.doughnut[key].title;
                            channels[key].backgroundColor = this.state.channels_style.doughnut[key].backgroundColor;
                            channels[key].hoverBackgroundColor = this.state.channels_style.doughnut[key].hoverBackgroundColor;
                            if(this.state.data[this.state.index].observations[i].channels[key]){
                                channels[key].value = this.state.data[this.state.index].observations[i].channels[key].impressions;
                            }else{
                                channels[key].value = 0;
                            }
                        }
                    }
                }

                for(var key in channels){
                    this.state.doughnutData.labels.unshift(channels[key].title);
                    this.state.doughnutData.datasets[0].backgroundColor.unshift(channels[key].backgroundColor);
                    this.state.doughnutData.datasets[0].hoverBackgroundColor.unshift(channels[key].hoverBackgroundColor);
                    observations.unshift(channels[key].value);
                }

                this.state.doughnutData.datasets[0].data = observations;
                this.setState({
                    chartData: Object.assign({}, this.state.chartData, {
                        datasets: datasets
                    }),
                    doughnutData: this.state.doughnutData
                });
            }
        }catch (e) {
            this.setState({data: null});
        }
    }

    _next(){
        this.state.index++;
        if(this.state.index > (this.state.data.length - 1)){
            this.state.index = 0;
        }
        try{
            if(!this.state.data[this.state.index].observations.length > 0){
                this.setState({index: this.state.index}, () => {
                    this._next();
                });
            }else{
                this.setState({index: this.state.index}, () => {
                    this._updateChartData();
                });
            }
        }catch (e) {
            this.setState({index: this.state.index}, () => {
                this._next();
            });
        }
    }

    _previous(){
        this.state.index--;
        if(this.state.index < 0){
            this.state.index = this.state.data.length - 1;
        }
        try{
            if(!this.state.data[this.state.index].observations.length > 0){
                this.setState({index: this.state.index}, () => {
                    this._next();
                });
            }else{
                this.setState({index: this.state.index}, () => {
                    this._updateChartData();
                });
            }
        }catch (e) {
            this.setState({index: this.state.index}, () => {
                this._next();
            });
        }
    }

    _renderTotalClicks(data){
        let leads = 0;
        try {
            for(let i = 0; i < data[this.state.index].observations.length; i++){
                for(let key in data[this.state.index].observations[i].channels){
                    leads = +leads + +data[this.state.index].observations[i].channels[key].clicks;
                }
            }
        }catch (e) {}
        return leads;
    }

    _renderTotalImpressions(data){
        let impressions = 0;
        try {
            for(let i = 0; i < data[this.state.index].observations.length; i++){
                for(let key in data[this.state.index].observations[i].channels){
                    impressions = +impressions + +data[this.state.index].observations[i].channels[key].impressions;
                }
            }
        }catch (e) {}
        return impressions;
    }

    _renderIndustry(){
        try{
            return this.state.data[this.state.index].industry
        }catch (e) {}
    }

    _renderIcon(key){
        if(salesChannelRegister.get("name") === "yieldlock"){
            let color = "#00273A";
            if(key === "google"){
                color = "rgb(0,39,58)";
            }else if(key === "fb"){
                color = "rgb(128,147,157)";
            }else if(key === "instagram"){
                color = "rgb(230,233,235)";
            }else if(key === "bing"){
                color = "rgb(191,201,206)";
            }
            let size = "cardSubtitleInnerIconsItem" + key;
            return (
                <div style={{backgroundColor: color}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                    <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                </div>
            )
        }else if(salesChannelRegister.get("name") === "propertybooster"){
            let color = "#000000";
            if(key === "google"){
                color = "rgb(26,107,133)";
            }else if(key === "fb"){
                color = "rgb(51,184,207)";
            }else if(key === "instagram"){
                color = "rgb(204,237,243)";
            }else if(key === "bing"){
                color = "rgb(153,219,231)";
            }
            let size = "cardSubtitleInnerIconsItem" + key;
            return (
                <div style={{backgroundColor: color}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                    <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                </div>
            )
        }else if(salesChannelRegister.get("name") === "boostabostad"){
            let color = "#000000";
            if(key === "google"){
                color = "rgb(104,171,75)";
            }else if(key === "fb"){
                color = "rgb(126,207,91)";
            }else if(key === "instagram"){
                color = "rgb(229,245,222)";
            }else if(key === "bing"){
                color = "rgb(174,236,147)";
            }
            let size = "cardSubtitleInnerIconsItem" + key;
            return (
                <div style={{backgroundColor: color}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                    <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                </div>
            )
        }else{
            let color = "cardSubtitleInnerIconsItemColor" + key;
            let size = "cardSubtitleInnerIconsItem" + key;
            return (
                <div className={
                    cx(Styles.cardSubtitleInnerIconsItem,
                        {
                            [Styles[color]]: this.state.open
                        })
                }>
                    <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                </div>
            )
        }
    }

    _renderNumbers(x) {
        try {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderText(item) {
        return langRegister.get("home-sections-nine", item);
    }

    render() {
        return (
            <div className={Styles.section}>
                <div className={Styles.container}>
                    {
                        this.state.data &&
                        <div className={Styles.item}>
                            <div className={Styles.itemLeft}>
                                <div className={Styles.itemLeftViews}>
                                    <div>
                                        <div className={Styles.itemLeftViewsTitle}>{this._renderText("item_1")}</div>
                                        <div className={Styles.itemLeftViewsValue}>{this._renderNumbers(this._renderTotalImpressions(this.state.data))}</div>
                                    </div>
                                </div>
                                <div className={Styles.itemLeftClicks}>
                                    <div>
                                        <div className={Styles.itemLeftClicksTitle}>{this._renderText("item_2")}</div>
                                        <div className={Styles.itemLeftClicksValue}>{this._renderNumbers(this._renderTotalClicks(this.state.data))}</div>
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.itemRight}>
                                <div className={Styles.itemRightTop}>
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.itemRightTopIndustry}>
                                        {this.state.data[this.state.index].industry}
                                        {/*DEACTIVATED CAMPAIGN SPEND*/}
                                        {/*{this.state.data[this.state.index].industry}: {this._renderNumbers(Math.round(this.state.data[this.state.index].total_budget))} {this.state.data[this.state.index].currency.toUpperCase()}*/}
                                    </div>
                                    <div className={Styles.itemRightTopDuration}>
                                        <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.itemRightTopDurationDays}>
                                            {this.state.data[this.state.index].days}&nbsp;{this._renderText("item_3")}
                                        </div>
                                        <div className={Styles.itemRightTopDurationIcons}>
                                            {
                                                this.state.data[this.state.index].channels.map((key, i) => {

                                                    return(
                                                        this._renderIcon(key)
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className={Styles.itemRightTopDoughnut}>
                                        {
                                            salesChannelRegister.get("name") !== "yieldlock" && (this.state.data[this.state.index].engagement > 0 || this.state.data[this.state.index].reactions > 0) &&
                                            <img className={Styles.sectionThreeLeftTopShareMobileHeart}
                                                 src={require('../../assets/images/heart_red.svg')}/>
                                        }
                                        {
                                            salesChannelRegister.get("name") === "yieldlock" && (this.state.data[this.state.index].engagement > 0 || this.state.data[this.state.index].reactions > 0) &&
                                            <img className={Styles.sectionThreeLeftTopShareMobileHeart}
                                                 src={require('../../assets/images/heart_red_yl.svg')}/>
                                        }
                                        {
                                            (this.state.data[this.state.index].engagement > 0 || this.state.data[this.state.index].reactions > 0) &&
                                            <div className={Styles.containerImageEngagement}>
                                                {this._renderNumbers((parseInt(this.state.data[this.state.index].engagement) + parseInt(this.state.data[this.state.index].reactions)))}
                                            </div>
                                        }
                                        {
                                            <Doughnut width={100} height={100} options={this.state.doughnutOptions} data={this.state.doughnutData}/>
                                        }
                                    </div>
                                </div>
                                <div className={Styles.itemRightBottom}>
                                    <div className={Styles.itemRightBottomLine}>
                                        {
                                            this.state.show &&
                                            <Line data={this.state.chartData} options={this.state.options}/>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default BoosterHomeCampaigns;


// WEBPACK FOOTER //
// ./src/components/booster-home-campaigns/component.js